import { FC, useState } from "react";
import { observer } from "mobx-react-lite";
import {
  MDSButton,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSTextField,
  MDSTextFieldVariant,
} from "@/mds";
import { useAppStore } from "@/store";
import { MDSText, MDSTextVariant } from "@/mds";
import styled from "@emotion/styled";

interface DeleteAccountModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

export const DeleteAccountModal: FC<DeleteAccountModalProps> = observer(
  ({ isOpen, handleClose }) => {
    const { pageStore } = useAppStore();
    const page = pageStore.settingsAccountManagementPage;

    return (
      <MDSModalDialog isOpen={isOpen} handleClose={handleClose}>
        <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
          Delete my Mem account
        </MDSText>

        <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
          <DeleteAccountModalContentDefault
            email={page.currentAccountEmail}
            handleDeleteAccount={page.handleDeleteAccount}
            isDeletingAccount={page.isDeletingAccount}
          />
        </MDSDialogTextContent>
      </MDSModalDialog>
    );
  }
);

const DeleteAccountModalContentDefault: FC<{
  email: string;
  handleDeleteAccount: () => Promise<void>;
  isDeletingAccount: boolean;
}> = ({ email, handleDeleteAccount, isDeletingAccount }) => {
  const [value, setValue] = useState<string>("");
  const hasUserConfirmed = value === "CONFIRM";
  return (
    <ModalContent>
      <MDSText variant={MDSTextVariant.ParagraphS}>
        This will close and delete this Mem account <strong>{email}</strong> permanently. This
        action is irreversible.
      </MDSText>
      <MDSText variant={MDSTextVariant.ParagraphS}>Please type CONFIRM to proceed.</MDSText>
      <MDSTextField
        variant={MDSTextFieldVariant.Form}
        autoFocus
        autoComplete="off"
        placeholder="Type CONFIRM"
        id="confirm-input"
        value={value}
        onChange={value => setValue(value)}
      />
      <MDSButton
        variant={MDSButtonVariant.DangerFilled}
        onClick={handleDeleteAccount}
        isDisabled={!hasUserConfirmed}
        isLoading={isDeletingAccount}
      >
        Delete my Mem account
      </MDSButton>
    </ModalContent>
  );
};

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.sm};
`;
